import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useContext, useRef, useEffect } from 'react';
import { CSSTransition as CSSTransition$1 } from 'react-transition-group';

var TransitionContext = /*#__PURE__*/React__default.createContext({
  parent: {}
});

function useIsInitialRender() {
  var isInitialRender = useRef(true);
  useEffect(function () {
    isInitialRender.current = false;
  }, []);
  return isInitialRender.current;
}

function CSSTransition(props) {
  var appear = props.appear,
      show = props.show,
      enter = props.enter,
      enterFrom = props.enterFrom,
      enterTo = props.enterTo,
      leave = props.leave,
      leaveFrom = props.leaveFrom,
      leaveTo = props.leaveTo,
      _onEnter = props.onEnter,
      _onEntering = props.onEntering,
      _onEntered = props.onEntered,
      _onExit = props.onExit,
      _onExiting = props.onExiting,
      _onExited = props.onExited,
      children = props.children;

  var parseClasses = function parseClasses(input) {
    if (!input) {
      return [];
    }

    if (Array.isArray(input)) {
      return input;
    }

    return [input];
  };

  var enterClasses = parseClasses(enter);
  var enterFromClasses = parseClasses(enterFrom);
  var enterToClasses = parseClasses(enterTo);
  var leaveClasses = parseClasses(leave);
  var leaveFromClasses = parseClasses(leaveFrom);
  var leaveToClasses = parseClasses(leaveTo);

  function addClasses(node, classes) {
    if (classes.length) {
      var _node$classList;

      (_node$classList = node.classList).add.apply(_node$classList, classes);
    }
  }

  function removeClasses(node, classes) {
    if (classes.length) {
      var _node$classList2;

      (_node$classList2 = node.classList).remove.apply(_node$classList2, classes);
    }
  }

  return React__default.createElement(CSSTransition$1, {
    appear: appear,
    unmountOnExit: true,
    "in": show,
    addEndListener: function addEndListener(node, done) {
      node.addEventListener('transitionend', function (event) {
        if (event.target === node) {
          done();
        }
      }, false);
    },
    onEnter: function onEnter(node) {
      addClasses(node, [].concat(enterClasses, enterFromClasses));

      if (_onEnter) {
        _onEnter();
      }
    },
    onEntering: function onEntering(node) {
      removeClasses(node, enterFromClasses);
      addClasses(node, enterToClasses);

      if (_onEntering) {
        _onEntering();
      }
    },
    onEntered: function onEntered(node) {
      removeClasses(node, [].concat(enterToClasses, enterClasses));

      if (_onEntered) {
        _onEntered();
      }
    },
    onExit: function onExit(node) {
      addClasses(node, [].concat(leaveClasses, leaveFromClasses));

      if (_onExit) {
        _onExit();
      }
    },
    onExiting: function onExiting(node) {
      removeClasses(node, leaveFromClasses);
      addClasses(node, leaveToClasses);

      if (_onExiting) {
        _onExiting();
      }
    },
    onExited: function onExited(node) {
      removeClasses(node, [].concat(leaveToClasses, leaveClasses));

      if (_onExited) {
        _onExited();
      }
    }
  }, children);
}

function Transition(props) {
  var show = props.show,
      appear = props.appear,
      rest = _objectWithoutPropertiesLoose(props, ["show", "appear"]);

  var _useContext = useContext(TransitionContext),
      parent = _useContext.parent;

  var isInitialRender = useIsInitialRender();
  var isChild = show === undefined;

  if (isChild) {
    return React__default.createElement(CSSTransition, _extends({
      appear: (parent == null ? void 0 : parent.appear) || !(parent == null ? void 0 : parent.isInitialRender),
      show: parent == null ? void 0 : parent.show
    }, rest));
  }

  return React__default.createElement(TransitionContext.Provider, {
    value: {
      parent: {
        show: show,
        isInitialRender: isInitialRender,
        appear: appear
      }
    }
  }, React__default.createElement(CSSTransition, _extends({
    appear: appear,
    show: show
  }, rest)));
}

export default Transition;
//# sourceMappingURL=index.esm.js.map
